<script>
    import _ from 'lodash';
    import {download} from '../../utils.js';
    import {store} from '../../stores.js';

    const axis = store('axis', '', false);
    const user = store('credential', 'getAuth');
    const sort = store('material-sort', '', '"order"');

    export let args;

    const export_csv = () => {
        let type = decodeURIComponent(location.href.split('/').pop());
        let output = "";

        document.querySelectorAll('.table tr').forEach(row => {
            let buf = [];
            row.querySelectorAll('th, td').forEach((cell) => {
                buf.push(cell.innerText)
            });
            output += buf.join(';') + "\n";
        });

        download('Расчёт материала для ' + type + '.csv', output);
    };
</script>

{#if args.item && args.item.quantity && Object.entries(args.item.materials ?? {}).length > 0 && $user && $user.tip.toLowerCase().includes('администратор')}
    <div class="card-header">
        Результат расчёта

        <div class="d-inline-block float-end">
            <div class="row">
                <div class="col-4">
                    <button class="btn btn-link {$sort === 'title' ? 'text-primary' : 'text-dark'} btn-sm p-0 m-0 border-0" on:click={() => sort.save('title')}>
                        <i class="fas fa-sort-alpha-down fa-lg"></i>
                    </button>
                </div>
                <div class="col-4">
                    <button class="btn btn-link {$sort === 'order' ? 'text-primary' : 'text-dark'} btn-sm p-0 m-0 border-0" on:click={() => sort.save('order')}>
                        <i class="fas fa-sort-numeric-down fa-lg"></i>
                    </button>
                </div>
                <div class="col-4">
                    <button class="btn btn-link text-dark btn-sm p-0 m-0 border-0" on:click={export_csv}>
                        <i class="fas fa-download fa-lg"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="card-body p-0 overflow-auto">
        <table class="table">
            <thead>
                <tr>
                    <th class="col">Материал</th>
                    <th class="col-1" style="text-align: right">
                        <span class="d-inline d-md-none"><b>Кол-во.</b></span>
                        <span class="d-none d-md-inline"><b>Количество</b></span>
                    </th>
                    <th class="col-1" style="text-align: right">Ед. изм.</th>
                    <th class="col-1" style="text-align: right">%</th>
                    <th class="col-1" style="text-align: right">Цена</th>
                    <th class="col-1" style="text-align: right">
                        <span class="d-inline d-md-none"><b>Стоим.</b></span>
                        <span class="d-none d-md-inline"><b>Стоимость</b></span>
                    </th>
                </tr>
            </thead>

            <tbody>
                {#each _.sortMaterials(args.item.materials ?? {}, $sort) as material, i}
                    <tr>
                        <td>{material.title}</td>
                        <td style="text-align: right">{(material.count * (material.quantity || 1)).toLocaleString()}</td>
                        <td style="text-align: right">{material.type}</td>
                        <td style="text-align: right">{(+material.spis).toFixed(1)}</td>
                        <td style="text-align: right">{(+material.oprice.rozn ).toLocaleString()}</td>
                        <td style="text-align: right">{(material.price.rozn * (material.quantity || 1)).toLocaleString()}</td>
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
{/if}
